<script>
    import { fly } from "svelte/transition";
    import { Selector } from "../index";
    let val;

    setTimeout(() => {
        val = ["1", "2"];
    }, 1000 * 2);
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">单选</h4>
    <div class="example-body">
        <Selector
            defaultValue={["1"]}
            options={[
                {
                    label: "选项一",
                    value: "1",
                },
                {
                    label: "选项二",
                    value: "2",
                },
                {
                    label: "选项三",
                    value: "3",
                },
            ]}
            on:change={(e) => console.log(e.detail)}
        />
    </div>
    <h4 class="example-title">多选</h4>
    <div class="example-body">
        <Selector
            defaultValue={["1", "2"]}
            multiple
            options={[
                {
                    label: "选项一",
                    value: "1",
                },
                {
                    label: "选项二",
                    value: "2",
                },
                {
                    label: "选项三",
                    value: "3",
                },
            ]}
            on:change={(e) => console.log(e.detail)}
        />
    </div>
    <h4 class="example-title">两列布局</h4>
    <div class="example-body">
        <Selector
            defaultValue={["1", "2"]}
            columns={2}
            multiple
            options={[
                {
                    label: "选项一",
                    value: "1",
                },
                {
                    label: "选项二",
                    value: "2",
                },
                {
                    label: "选项三",
                    value: "3",
                },
            ]}
        />
    </div>
    <h4 class="example-title">禁用状态</h4>
    <div class="example-body">
        <Selector
            defaultValue={["1", "2"]}
            columns={3}
            disabled
            options={[
                {
                    label: "选项一",
                    value: "1",
                },
                {
                    label: "选项二",
                    value: "2",
                },
                {
                    label: "选项三",
                    value: "3",
                },
            ]}
        />
        <br />
        <Selector
            defaultValue={["1", "2"]}
            columns={2}
            multiple
            options={[
                {
                    label: "选项一",
                    value: "1",
                },
                {
                    label: "选项二",
                    value: "2",
                    disabled: true,
                },
                {
                    label: "选项三",
                    value: "3",
                },
            ]}
        />
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .rect {
        background: #eee;
        width: 40px;
        height: 40px;
        display: block;
        border-radius: 8px;
    }
</style>
